import { getSDK, type ActionCard } from '@littlebird/sdk';

import { hasViewFor } from './cardRow';

import type { WebSurface } from './analytics';

export type CardRendering = 'card' | 'fallback' | 'loading';

export const rendersAsCardV2 = (
  card: ActionCard,
  surface: WebSurface
): boolean => card.actionType !== 'agent_team' && hasViewFor(card, surface);

export const useCardRendering = (
  card: ActionCard,
  surface: WebSurface
): CardRendering => {
  // Views and documents arrive by sync on the same MobX objects, so React Compiler must not cache this
  'use no memo';
  if (rendersAsCardV2(card, surface)) return 'card';
  // A card without a view waits for the documents, and gets the fallback once they load or fail
  const { templates, templatesFailed } = getSDK().stores.actionCards;
  return templates === null && !templatesFailed ? 'loading' : 'fallback';
};
